import React from 'react';
import { daysOfWeek } from "./Month";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowClose } from '@fortawesome/free-solid-svg-icons';

const SingleDay = ({adminFuncs, singleDayData, monthName, history, isAdmin}) => {
  let { dayOfWeek, date, holiday, message, events } = singleDayData;

  const handleCloseSingleDay = () => {
    history.goBack();
  }

  const formatDateDisplay = () => {
    return `${daysOfWeek[dayOfWeek].full}, ${monthName} ${date}`;
  }

  const formatEventCount = () => {
    const count = events.length;
    if (count === 0) return "No classes scheduled";
    return `${count} ${count === 1 ? "class" : "classes"} scheduled`;
  }

  return (
    <div className="singleDayContainer">
      <div className="singleDayWrap">
        <div className="singleDayHeaderContainer">
          <div className="singleDayHeaderUpperWrap">
            <p className="singleDayHeaderText">{formatDateDisplay()}</p>
            <i onClick={handleCloseSingleDay}>
              <FontAwesomeIcon icon={faWindowClose} className="singleDayHeaderIcon" />
            </i>
          </div>
          <p className="singleDayHeaderText">{formatEventCount()}</p>
        </div>

        {holiday && (
          <div className="single-day-holiday">
            <p>{holiday}</p>
            {message && <p>{message}</p>}
          </div>
        )}

        {events.length > 0 ? (
          events.map(({courseName, startTime, endTime, locationLine1, locationLine2}, index) => (
            <div className="singleDayClassContainer" key={`${courseName}${index}`}>
              <div className="single-day-class-info">
                <p className="class-title">{courseName}</p>
                <p className="class-time">{`${startTime} - ${endTime}`}</p>
                {locationLine1 && <p className="class-location">{locationLine1}</p>}
                {locationLine2 && <p className="class-location">{locationLine2}</p>}
              </div>
              
              {isAdmin && (
                <div className="singleDayFooterContainer">
                  <button 
                    className="singleDayButton"
                    onClick={() => adminFuncs.removeClass(index, date)}>
                    Remove Class
                  </button>
                  <button 
                    className="singleDayButton"
                    onClick={() => adminFuncs.updateClass(index, date)}>
                    Update Class
                  </button>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="no-classes-message">
            <p>No classes scheduled for this day</p>
          </div>
        )}

        {isAdmin && (
          <div className="singleDayFooterContainer">
            <button 
              className="singleDayButton"
              onClick={() => adminFuncs.addClass(date)}>
              Add a Class
            </button>
          </div>
        )}
      </div>
    </div>
  ) 
}

export default SingleDay;